import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

export function WaitlistBand() {
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("seller");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/waitlist", { email, role });
      toast.success("You're on the list. We'll write when we open the gates.");
      setEmail("");
    } catch {
      toast.error("Something went wrong. Try again?");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="waitlist-band" className="relative bg-[var(--gu-dark-bg)] text-[var(--gu-dark-text)] overflow-hidden">
      <div className="absolute inset-0 opacity-25">
        <img src="https://images.unsplash.com/photo-1701186598427-5eb8f1717d2a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxtb29keSUyMGdyZWVuaG91c2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODM5MTUwOTV8MA&ixlib=rb-4.1.0&q=85" className="w-full h-full object-cover" alt="" />
        <div className="absolute inset-0 bg-[var(--gu-dark-bg)]/60" />
      </div>
      <div className="relative max-w-[1200px] mx-auto px-6 lg:px-12 py-24 lg:py-32 grid grid-cols-12 gap-8">
        <div className="col-span-12 lg:col-span-6">
          <div className="overline text-[var(--gu-dark-muted)] mb-6">Coming soon</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight leading-[0.95]">
            Are you a grower?<br />Come sell with us.
          </h2>
          <p className="mt-8 text-[var(--gu-dark-muted)] leading-relaxed max-w-md">
            Grace Under Umbrella will soon open to other small growers. Cuttings, cultivars,
            hand-thrown pots. Join the waitlist and we'll open a stall for you.
          </p>
        </div>
        <form onSubmit={submit} className="col-span-12 lg:col-span-5 lg:col-start-8 lg:pt-24">
          <div className="flex gap-6 mb-6 overline">
            <label className="flex items-center gap-2 cursor-pointer">
              <input type="radio" name="role" value="seller" checked={role === "seller"} onChange={(e) => setRole(e.target.value)} data-testid="waitlist-role-seller" className="accent-[var(--gu-dark-text)]" />
              I want to sell
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input type="radio" name="role" value="buyer" checked={role === "buyer"} onChange={(e) => setRole(e.target.value)} data-testid="waitlist-role-buyer" className="accent-[var(--gu-dark-text)]" />
              Just tell me when
            </label>
          </div>
          <div className="flex items-end border-b border-[var(--gu-dark-border)] pb-2">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              data-testid="waitlist-email"
              className="flex-1 bg-transparent border-0 outline-none py-2 text-lg placeholder:text-[var(--gu-dark-muted)]/60"
            />
            <button type="submit" disabled={loading} data-testid="waitlist-submit" className="overline pl-6 hover:text-[var(--gu-accent)] transition-colors disabled:opacity-50">
              {loading ? "Sending…" : "Join list →"}
            </button>
          </div>
          <p className="mt-4 text-xs text-[var(--gu-dark-muted)]">We only write when there's leaf news.</p>
        </form>
      </div>
    </section>
  );
}
